import React from "react"
import { AppDispatch } from "../../../reduxStore/store"
import { useDispatch, useSelector } from "react-redux"
import {
  ErrorState,
  selectErrorHandler,
  errorHandlerUpdated,
} from "../errorSlice"
import cn from "../../../utils/classes"
import { Banner } from "../../shared/components/Banner"

export const BannerIds = {
  PRACTICE_INDIVIDUALS: { info: "practice-individuals-info" },
  ADVANCED_SEARCH: {
    info: "advanced-search-info",
    error: "advanced-search-error",
  },
  REFERRAL_LIST: { info: "referral-list-info" },
  PAYMENTS: { info: "payments-info" },
  SITE_OUTAGE: { error: "site-outage-error" },
  PRACTICE_AGREEMENT_SIGNATURE: {
    actionNeeded: "practice-agreement-signature-required",
  },
}

interface BannerWithIdProps {
  id: string
  styleOverrides?: string
  disableClose?: boolean
}

export const BannerWithId: React.FC<BannerWithIdProps> = ({
  id,
  styleOverrides,
  disableClose,
}) => {
  const dispatch: AppDispatch = useDispatch()
  const errorState: ErrorState = useSelector(selectErrorHandler)
  const banner = errorState.bannersWithId.find((b) => b.id === id)

  if (!banner) return null

  const handleOnBannerClose = () => {
    dispatch(
      errorHandlerUpdated({
        bannersWithId: errorState.bannersWithId.filter((b) => b.id !== id),
      }),
    )

    banner.onClose?.()
  }

  const className = cn(styleOverrides)

  return (
    <Banner
      type={banner.type}
      title={banner.title}
      content={banner.content}
      isOpen={!!banner}
      onClose={disableClose ? undefined : handleOnBannerClose}
      id={banner.id}
      sticky={true}
      styleOverrides={`${className} z-10`}
      contentStyleOverrides="text-base"
      titleStyleOverrides="text-base"
    />
  )
}

export default BannerWithId
